import { render, staticRenderFns } from "./PosCriarConta.vue?vue&type=template&id=6235bfcc"
import script from "./PosCriarConta.vue?vue&type=script&lang=js"
export * from "./PosCriarConta.vue?vue&type=script&lang=js"
import style0 from "./PosCriarConta.vue?vue&type=style&index=0&id=6235bfcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports